<mat-form-field appearance="outline" class="full-width custom-mat-field">
  <mat-label *ngIf="!hasValue()">{{ label | translate }}</mat-label>
  <mat-select #matSelect [formControl]="control" [compareWith]="compareFn" msInfiniteScroll
    (infiniteScroll)="onLoadMore()">
    <mat-option *ngFor="let option of options" [value]="option[valueKey]">
      {{ option[labelKey] | translate }}
    </mat-option>
  </mat-select>
  <button
    *ngIf="hasValue()"
    type="button"
    class="clear-icon"
    (click)="resetFilter($event)"
    aria-label="Clear"
    title="Xóa"
  >×</button>
</mat-form-field>
<span class="errorTxt__custom" *ngIf="control?.invalid && (control?.dirty || isSubmit)">
  {{ errorMessage }}
</span>